module.exports = __webpack_public_path__ + "static/img/tky-kcbg1-nor@2x.489b4faa.png";